export const ALL_FOLDERS_LIST = 'ALL_FOLDERS_LIST';
export const SEARCHED_FILES = "SEARCHED_FILES";
